<template>
  <transition v-if="showButton" name="component-fade">
    <button class="nav-arrow nav-arrow--left" @click="$emit('click', $event)">
      <svg width="32" height="32">
        <use xlink:href="#icon-arrow-left" />
      </svg>
    </button>
  </transition>
</template>

<script>
export default {
  computed: {
    showButton() {
      let viewState = true;
      if (
        this.$store.getters.getInformationViewState == true ||
        this.$store.getters.getCompareViewState == true ||
        this.$store.getters.getChangeTarrifViewState == true
      ) {
        viewState = false;
      }
      return viewState;
    }
  }
};
</script>
